// extracted by mini-css-extract-plugin
export default {"sponsoredBanner":"RX-z","sponsoredTooltipWrapper":"SX-z","sponsoredTooltip":"TX-z","newCard":"UX-z"};